import { QUERY_KEYS } from "@forwardflow/helpers/utils/constants";
import PhoneNumberService from "@forwardflow/services/PhoneNumberService";

import { PaginationQueryParams } from "@forwardflow/types";
import useSWR from "swr";

export const useGetAvailablePhoneNumbers = (
   queryParams: PaginationQueryParams
) => {
   const response = useSWR([QUERY_KEYS.ALL_CAMPAIGNS, { ...queryParams }], () =>
      PhoneNumberService.getAvailablePhoneNumbers(queryParams)
   );
   return {
      ...response,
   };
};
